import React from "react";

export default function Defs({ isTransparent }) {
  return (
    <>
      <defs>
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-5-2"
          d="M200.765 499.14h1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-90-5"
          d="M200.765 493.848h1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-7-0"
          d="M200.765 488.557h1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-96-0"
          d="M200.765 483.265h1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-3-3"
          d="M200.765 477.973h1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-9-2"
          d="M200.765 472.682h1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-2"
          d="M200.765 467.39h1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-5"
          d="M200.765 496.494h2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-90"
          d="M200.765 491.203h2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-7"
          d="M200.765 485.911h2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-96"
          d="M200.765 480.62h2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-3"
          d="M200.765 475.328h2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-9"
          d="M200.765 470.036h2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358"
          d="M200.765 464.744h2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1874"
          d="M103.233 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1872"
          d="M108.524 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1870"
          d="M113.816 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1868"
          d="M119.108 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1860"
          d="M105.878 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1858"
          d="M111.17 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1856"
          d="M116.462 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1556"
          d="M81.537 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1554"
          d="M86.828 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1552"
          d="M92.12 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1550"
          d="M97.412 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1542"
          d="M84.183 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1540"
          d="M89.474 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1538"
          d="M94.766 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1536"
          d="M100.058 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-5-2-9"
          d="M45.024 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-90-5-9"
          d="M50.316 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-7-0-2"
          d="M55.608 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-96-0-4"
          d="M60.9 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-3-3-2"
          d="M66.191 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-9-2-9"
          d="M71.483 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-2-7"
          d="M76.774 171.396v1.24"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-5-6"
          d="M47.67 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-90-1"
          d="M52.962 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-7-1"
          d="M58.253 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-96-5"
          d="M63.545 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-3-6"
          d="M68.837 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-9-9"
          d="M74.129 171.396v2.68"
          overflow="visible"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path3358-0"
          d="M79.42 171.396v2.68"
          overflow="visible"
        />
      </defs>
      <defs>
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1278"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M235.875-16.866l2.333-1.347"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1276"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M237.664-15.077l1.347-2.333"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1274"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M242.552-15.077l-1.347-2.333"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1272"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M244.342-16.866l-2.333-1.347"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1270"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M244.342-21.754l-2.333 1.347"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1268"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M242.552-23.544l-1.347 2.333"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1266"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M235.875-21.754l2.333 1.347"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1264"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M237.664-23.544l1.347 2.333"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1262"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M235.22-19.31h2.694"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1260"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M240.108-14.422v-2.694"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1258"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M244.997-19.31h-2.694"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1256"
          fill="#1a1a1a"
          stroke="#4a4a4a"
          strokeLinecap="round"
          strokeMiterlimit="4"
          strokeOpacity="1"
          strokeWidth="0.529"
          d="M240.108-24.198v2.693"
        />
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1235"
          fill="#4d4d4d"
          stroke="none"
          d="M238.491-20.087c.303.05.27 2.537 0 2.599-.271-.066-.283-2.61 0-2.599z"
        />

        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="path1142"
          fill="#4d4d4d"
          stroke="none"
          strokeMiterlimit="4"
          strokeWidth="0.265"
          d="M-143.59 202.69c.303.05.27 2.536 0 2.598-.27-.066-.283-2.61 0-2.598z"
        />

        {/* ScrewHeadGroove */}
        <path
          className={`tapeComponent ${isTransparent && "transparent"}`}
          id="screwHeadGroove"
          fill="#4d4d4d"
          stroke="none"
          d="M227.493-63.383c.303.05.27 2.536 0 2.599-.271-.066-.283-2.61 0-2.599z"
        />

        {/* SCREW HEAD */}
        <radialGradient id="wheelScrewHead">
          <stop offset="10%" stopColor="white" />
          <stop offset="95%" stopColor="grey" />
        </radialGradient>

        <linearGradient>
          <stop offset="0" stopColor="#858186" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient>
          <stop offset="0" stopColor="#858186" stopOpacity="1"></stop>
        </linearGradient>
        <linearGradient id="linearGradient1156">
          <stop offset="0" stopColor="#dfd5d1" stopOpacity="1"></stop>
          <stop offset="1" stopColor="#9b948e" stopOpacity="1"></stop>
        </linearGradient>

        {/* VOLUME SLIDER MARKS */}
        <defs>
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-5-2"
            d="M200.765 499.14h1.24"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-90-5"
            d="M200.765 493.848h1.24"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-7-0"
            d="M200.765 488.557h1.24"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-96-0"
            d="M200.765 483.265h1.24"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-3-3"
            d="M200.765 477.973h1.24"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-9-2"
            d="M200.765 472.682h1.24"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-2"
            d="M200.765 467.39h1.24"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-5"
            d="M200.765 496.494h2.68"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-90"
            d="M200.765 491.203h2.68"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-7"
            d="M200.765 485.911h2.68"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-96"
            d="M200.765 480.62h2.68"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-3"
            d="M200.765 475.328h2.68"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358-9"
            d="M200.765 470.036h2.68"
          />
          <path
            className={`tapeComponent ${isTransparent && "transparent"}`}
            id="path3358"
            d="M200.765 464.744h2.68"
          />
        </defs>
      </defs>
    </>
  );
}
